
<!-- <h1>{{ message }}</h1> -->

<div>

    <div class="input-group">
        <div class="input-group-append">
            <input class="input-group-text" type="text" placeholder="{{ message }}" [(ngModel)]="searchTerm" (input)="onSearchChange()" name="searchRfc"/>
        </div>

        <div class="input-group-append">
            <select class="form-select" id="rfcSociedad" #rfcSociedadInput (change)="onSocietyChange($event.target.value)">                    
            <!-- <select class="form-select" id="rfcSociedad" #rfcSociedadInput> -->
              <option *ngFor="let item of filteredSociedadLista" [value]="item.rfc">
                {{item.rfc}} - {{item.razonSocial}}
              </option>
            </select>                        
        </div>        
        <!-- <h6>{{ selectedSociety }}</h6> -->
    </div>
    
</div>
